import React from 'react';
import { RouteProps } from 'react-router-dom';
import { demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides: RouteProps[] = [
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.forgotPassword.path, element: null },
	{ path: demoPagesMenu.resetPassword.path, element: null },
	{ path: demoPagesMenu.createAccount.path, element: null },
	{ path: demoPagesMenu.encryptText.path, element: null },
	// { path: demoPagesMenu.createAccount2.path, element: null },
	// { path: demoPagesMenu.createAccount3.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: '*', element: <DefaultAside /> },
];

export default asides;
